module.exports = __webpack_public_path__ + "img/Ichilov_Medical_Center.c38325d3.svg";